<template>
  <div class="mk-image-group-container">
    <img :src="childItem.propsValue.data[0].customField1" width="100%" height="100%" />
  </div>
</template>

<script>
import { buttonObject } from "@/modules/autoweb/config/elementObject.js";
let tempButtonObject = _.cloneDeep(buttonObject);
tempButtonObject.text = "";
export default {
  name: "MkImageGroupPhone",
  props: {
    childItem: {
      type: Object,
      default: () => {
        return {};
      }
    }
  },
  data() {
    return {
      fields: [
        {
          code: "customField1",
          label: "图片",
          type: "image",
          width: 750,
          height: 550
        },
        {
          code: "customField2",
          label: "点击",
          type: "button"
        }
      ],
      data: [
        {
          customField1:
            "https://mks.yybip.com/200x/group1/M00/0B/61/CgoRC2iIbAaAdJFnAAF_dzBYHS0710.png",
          customField2: tempButtonObject
        }
      ]
    };
  }
};
</script>

<style scoped lang="scss">
.mk-image-group-container {
  width: 100%;
  height: 100%;
  position: relative;
  img {
    width: 100%;
    height: auto;
  }
}
</style>
